module.exports = __webpack_public_path__ + "media/invite/credits-75b2ddc0.svg";